import React from "react";
import { useAppStore } from "@/store/useAppStore";

export const GameModeSelector = () => {
  const { gameMode, setGameMode } = useAppStore();
  return (
    <div className="flex justify-center mb-8">
      <div className="bg-white/5 backdrop-blur-xl rounded-xl p-1 border border-white/10">
        <button
          onClick={() => setGameMode("solo")}
          className={`px-2 sm:px-4 py-2 rounded-lg text-sm transition-all duration-300 cursor-pointer ${
            gameMode === "solo"
              ? "bg-brand-teal text-white"
              : "text-gray-400 hover:text-white"
          }`}
        >
          🎯 Solo Training
        </button>
        <button
          onClick={() => setGameMode("crowd")}
          className={`px-2 sm:px-4 py-2 rounded-lg text-sm transition-all duration-300 cursor-pointer ${
            gameMode === "crowd"
              ? "bg-brand-teal text-white"
              : "text-gray-400 hover:text-white"
          }`}
        >
          👥 Beat the Crowd
        </button>
      </div>
    </div>
  );
};
